function Facebook() {
  return (
    <svg
      width="20"
      height="21"
      className="facebook-icon"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.8917 0.5H1.10833C0.815059 0.502181 0.534415 0.619651 0.327033 0.827033C0.119651 1.03442 0.00218057 1.31506 0 1.60833V19.3917C0.00218057 19.6849 0.119651 19.9656 0.327033 20.173C0.534415 20.3803 0.815059 20.4978 1.10833 20.5H10.6833V12.7667H8.08333V9.74167H10.6833V7.51667C10.6833 4.93333 12.2583 3.525 14.575 3.525C15.35 3.525 16.125 3.525 16.9 3.64167V6.33333H15.3083C14.05 6.33333 13.8083 6.93333 13.8083 7.80833V9.73333H16.8083L16.4167 12.7583H13.8083V20.5H18.8917C19.1849 20.4978 19.4656 20.3803 19.673 20.173C19.8803 19.9656 19.9978 19.6849 20 19.3917V1.60833C19.9978 1.31506 19.8803 1.03442 19.673 0.827033C19.4656 0.619651 19.1849 0.502181 18.8917 0.5V0.5Z"
        fill="url(#paint0_linear_14427_87837)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_14427_87837"
          x1="0.208333"
          y1="20.2917"
          x2="20"
          y2="0.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBF17" />
          <stop offset="1" stopColor="#F2E2B8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Facebook;
